import React from 'react';

export default function JenisDokumen() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Jenis Dokumen</h1>
      <p className="text-gray-500">Halaman Jenis Dokumen</p>
    </div>
  );
}
